import React, {useState} from "react";
import {Button, Icon, message, Upload} from "antd";

interface ResumeFileUploadProps {
  maxSize: number;
  onFileSelect: (file: File | null) => void;
  disabled?: boolean;
}

const ResumeFileUpload: React.FC<ResumeFileUploadProps> = ({
                                                             maxSize,
                                                             onFileSelect,
                                                             disabled = false
                                                           }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const validateFile = (file: File) => {
    const isSmolEnough = file.size <= maxSize;
    if (!isSmolEnough) {
      message.error(
        `File is too large. Max file size is ${maxSize /
        1000}KB. Consider compressing the file.`
      );
    }

    const isAllowedType =
      file.type === "application/pdf" ||
      file.type === "application/msword" ||
      file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

    if (!isAllowedType) {
      message.error("Please upload a PDF or Word document (.pdf, .doc, .docx)");
      return false;
    }


    return isSmolEnough;
  };

  const handleFileSelect = (file: File) => {
    if (!validateFile(file)) {
      setSelectedFile(null);
      onFileSelect(null);
      return false;
    }

    setSelectedFile(file);
    onFileSelect(file);
    return false;
  };

  const handleRemove = () => {
    setSelectedFile(null);
    onFileSelect(null);
  };

  return (
    <div style={{position: "relative", display: "inline-block"}}>
      <Upload.Dragger
        name="file"
        multiple={false}
        accept="
  application/pdf,
  application/msword,
  application/vnd.openxmlformats-officedocument.wordprocessingml.document
"
        beforeUpload={handleFileSelect}
        showUploadList={false}
        disabled={disabled}
      >
        <p className="ant-upload-drag-icon">
          <Icon type="inbox"/>
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Upload resume file.
        </p>
      </Upload.Dragger>

      {selectedFile && (
        <div
          style={{
            marginTop: 8,
            padding: 8,
            backgroundColor: "#f0f0f0",
            borderRadius: 4
          }}
        >
          <span>Selected: {selectedFile.name}</span>
          <Button
            type="link"
            size="small"
            onClick={handleRemove}
            style={{float: "right"}}
          >
            Remove
          </Button>
        </div>
      )}
    </div>
  );
};

export default ResumeFileUpload;
